import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const FocusOnScroll = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        setTimeout(() => {
          element.focus({ preventScroll: true });
        }, 0);
      }
    }
  }, [location]);

  return null;
};

export default FocusOnScroll;
